var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "function"
  }, [_c("div", {
    staticClass: "function_main"
  }, [_c("Title", {
    staticClass: "function_main_title",
    attrs: {
      title: "功能介绍"
    }
  }), _c("div", {
    staticClass: "function_main_list"
  }, _vm._l(_vm.functionList, function (item, index) {
    return _c("Card", {
      key: index,
      attrs: {
        title: item.title,
        desc: item.desc,
        img: item.img
      }
    });
  }), 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };